





























import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import LendingInterestSettingsEdit from '@/components/Products/Forms/Lending/LendingInterestSettingsEdit.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';

@Component({ name: 'LendingInterestSettingsEditDialog', components: { LendingInterestSettingsEdit } })
export default class extends SaascadaVueDialog {

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            ProductDetailsModule.prepareProductViewModel();
            await ProductDetailsModule.getRateSources();
        }
    }

    get productType() {
        return ProductDetailsModule.product.generalSettings.subType;
    }

    async save() {
        if (!(this.$refs.form as any).validateForm()) {
            return;
        }
        else {
            this.dialog = false;
            await ProductDetailsModule.editLendingInterestSettings();
            await ProductDetailsModule.getHistory();
        }
    }

}
